import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import App from './App.vue'

import LazyLoadDirective from "./directives/lazy.js";

import about   from './components/about.vue'
import contact from './components/contact.vue'
import studio  from './components/studio.vue'
import gallery from './components/gallery.vue'

Vue.use(VueAxios, axios)
Vue.use(VueRouter)

Vue.config.productionTip = false

Vue.directive("lazyload", LazyLoadDirective);

const global_vars = Vue.observable({
  router: null
})
Vue.prototype.$var = global_vars

const routes = [
  { path: '/about', component: about },
  { path: '/contact', component: contact },
  { path: '/studio', component: studio },
  { path: '/gallery/:page', component: gallery, props: true }
]

const router = new VueRouter({
  routes
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

Vue.prototype.$var.router = router
router.push('/gallery/portraits')
